import { axios } from '@lib/axios';

import { LegalEntityStatus } from 'chaika-enums';
import {
    LegalEntityCreateForm,
    LegalEntityData,
    LegalEntityListQuery,
    LegalEntityListResponse,
    LegalEntityResponse,
    LegalEntityUpdateForm,
} from 'chaika-frontend-types/frontend-cms';

const BASE_URL = '/api/legal-entity';

export class LegalEntityApi {
    public static async get(id: string): Promise<LegalEntityData> {
        const res = await axios.get<LegalEntityResponse>(`${BASE_URL}/${id}`);
        return res.data.legalEntity;
    }

    public static async getList(params?: LegalEntityListQuery): Promise<LegalEntityData[]> {
        const res = await axios.get<LegalEntityListResponse>(BASE_URL, { params });
        return res.data.legalEntities;
    }

    public static async updateStatus(id: string, status: LegalEntityStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { status });
    }

    public static async create(legalEntity: LegalEntityCreateForm): Promise<void> {
        await axios.post(BASE_URL, { legalEntity });
    }

    public static async update(id: string, legalEntity: LegalEntityUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { legalEntity });
    }
}

export { BASE_URL as LEGAL_ENTITY_BASE_URL };
